<template>
    <div>
        <div class="center mt-5 px-3">
            <router-link to="/" class="navbar-brand">
                <img src="../assets/img/logo/enginehire logo thin dark 1.0 letterpaths.svg" alt="" height="55">
            </router-link>
            <h3 class="mt-5">We are excited to meet you. (:</h3>
            <div style="">
                <p style="max-width: 600px; display: block; margin-left: auto; margin-right: auto;" class="px-2 mt-4 mb-4">Get a step by step run through of the process a candidate and client would take through your system, and the tools at your disposal to manage and automate everything. See for yourself exactly how some of the companies using Enginehire use it, and why they love it!</p>
            </div>
            <div class="meetings-iframe-container mb-5" data-src="https://meetings.hubspot.com/aakash-goel?embed=true"></div>
            <!-- https://stackoverflow.com/questions/45047126/how-to-add-external-js-scripts-to-vuejs-components -->
            <script type="application/javascript" src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"></script>
        </div>
    </div>
</template>

<script>
export default {
    created () {
        // Scroll the window to top on load
        window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
}
</script>


// WEBPACK FOOTER //
// src/components/BookDemo.vue